const t = {
  name: "Mumbai",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M9 6V4H7V9H1V20H3V11H7V20H9V8H15V20H17V11H21V20H23V9H17V4H15V6H9Z" fill="currentColor"/>
<path d="M20 14H18V20H20V14Z" fill="currentColor"/>
<path d="M6 20V14H4V20H6Z" fill="currentColor"/>
<path d="M13 12V20H11V12H13Z" fill="currentColor"/>
</svg>
  `
};
export {
  t as Mumbai
};
